export default __webpack_public_path__ + "static/media/Install1.711c813a.png";